import React from 'react'
import { formatPrice } from '../utils/pricing'

const Price = ({ value }: { value: string | number }) => {
  const total = typeof value === 'string' ? parseFloat(value) : value

  return (
    <span>
      {total < 0 ? `(${formatPrice(Math.abs(total))})` : formatPrice(total)}
    </span>
  )
}

export default Price
